import { render, staticRenderFns } from "./userSelector.vue?vue&type=template&id=0baf1973&scoped=true"
import script from "./userSelector.vue?vue&type=script&lang=js"
export * from "./userSelector.vue?vue&type=script&lang=js"
import style0 from "./userSelector.vue?vue&type=style&index=0&id=0baf1973&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baf1973",
  null
  
)

export default component.exports